'use client';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@eliadmin/core/src/components/ui/select';
import { useCategorySort } from '@eliadmin/core/src/hooks/category/use-category-sort';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { RiExpandUpDownFill } from 'react-icons/ri';

type CategorySortProps = {
  className?: string;
};

export function CategorySort(props: CategorySortProps) {
  const { className } = props;
  const { t } = useTranslations();

  const { selectedValue, onSortChange, VALUES } = useCategorySort();

  return (
    <div
      className={cn(
        'flex w-full items-center justify-end gap-3 sm:w-fit',
        'ea-category-sort',
        className,
      )}
    >
      <p className="hidden text-sm font-light text-foreground sm:block">{t('text2355')}:</p>
      <div className={cn('w-full sm:w-fit', 'ea-category-sort__select-wrapper')}>
        <Select value={selectedValue} onValueChange={e => onSortChange(e)}>
          <SelectTrigger
            aria-label={`${t('text2355')}: ${t(VALUES.find(option => String(option.value) === selectedValue)?.label ?? 'text341')}`}
            // placeholder={`${t('text341')}..`}
            innerTriggerClassName="w-full px-3"
            className={cn(
              'h-[42px] w-full whitespace-nowrap rounded-[8px] border border-border bg-transparent px-0',
              'ea-category-sort__select-trigger',
            )}
            isClearable={!!selectedValue}
            onClear={() => {
              if (!selectedValue) return;
              onSortChange('');
            }}
            clearIcon={null}
            expandIcon={<RiExpandUpDownFill size={20} className="ml-12 text-primary" />}
          >
            <SelectValue
              placeholder={`${t('text341')}..`}
              className={cn('whitespace-nowrap', 'ea-category-sort__select-value')}
            />
          </SelectTrigger>
          <SelectContent className={cn('', 'ea-category-sort__select-content')}>
            {VALUES?.map(o => (
              <SelectItem
                key={o.value}
                value={String(o.value)}
                className={cn('', 'ea-category-sort__select-item')}
              >
                {t(o.label)}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}

export default CategorySort;
